module.exports = __webpack_public_path__ + "6d0e71d3a0f41acd3a9f278d6f42b729.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/social/speakers/maja-wichrowska.jpg
// module id = 517
// module chunks = 0